import * as z from 'zod';
import { CatalogType, OralQuantityBasis } from '../../../database/schema.js';
import { Status } from '../../../util/schemas.js';
import { AddStabilityRuleSchema } from '../../utils/stability-rules.js';
export const AddMedicationProfileSchema = z.object({
    medicineFormId: z.uuidv7().nonoptional(),
    name: z.string(),
    reconstitutionRequired: z.boolean(),
    isDrySubstance: z.boolean(),
    reconstitutionDiluentsIds: z.array(z.uuidv7()),
    oralQuantityBasis: OralQuantityBasis.optional(),
    status: Status.optional(),
    stabilityRules: z.array(AddStabilityRuleSchema),
    id: z.uuidv7().optional(), // used to differentiate between already existing items and new items
});
export const UpdateMedicationProfileSchema = AddMedicationProfileSchema;
export const AddDrugItemSchema = z.object({
    catalogType: CatalogType,
    name: z.string().trim().nonempty(),
    prescribingName: z.string().optional(),
    code: z.string().optional(), // internal ID
    nationalId: z.string().optional(),
    atcCode: z.string().optional(),
    categoriesIds: z.array(z.uuidv7()),
    description: z.string().optional(),
    medicationProfiles: z.array(AddMedicationProfileSchema),
    /**
     * Smart compounder machine master-data id. Keeps a `compound_mappings` row
     * (`sourceId` = this drug item's id) in sync for the DRUG or CARRIER mapping
     * type depending on the catalog type. Empty clears the mapping.
     */
    machineId: z.string().trim().optional(),
});
export const UpdateDrugItemSchema = AddDrugItemSchema.partial().extend({ id: z.uuidv7().nonempty() });
//# sourceMappingURL=schemas.js.map